var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99537 9.76742L7.64935 6.01892L3.99537 2.27042C3.92995 2.20344 3.89333 2.11354 3.89333 2.01992C3.89333 1.9263 3.92995 1.83639 3.99537 1.76942C4.02714 1.73699 4.06506 1.71123 4.10692 1.69364C4.14877 1.67605 4.19372 1.66699 4.23912 1.66699C4.28452 1.66699 4.32946 1.67605 4.37131 1.69364C4.41317 1.71123 4.45109 1.73699 4.48287 1.76942L8.37085 5.75717C8.43911 5.8272 8.47732 5.92112 8.47732 6.01892C8.47732 6.11671 8.43911 6.21064 8.37085 6.28067L4.48362 10.2684C4.45182 10.3011 4.4138 10.327 4.37181 10.3448C4.32982 10.3625 4.2847 10.3716 4.23912 10.3716C4.19354 10.3716 4.14842 10.3625 4.10642 10.3448C4.06443 10.327 4.02641 10.3011 3.99462 10.2684C3.9292 10.2014 3.89258 10.1115 3.89258 10.0179C3.89258 9.9243 3.9292 9.83439 3.99462 9.76742L3.99537 9.76742Z",
    fill: "#00438B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.6d69d7acef60d3dcd9024fa0f30fb82e.svg";
export { ForwardRef as ReactComponent };